import renderComponent from 'recompose/renderComponent';
import branch from 'recompose/branch';
import FullPageLoading from '../Components/FullPageLoading';

const spinnerWhileLoading = isLoading => branch(
    isLoading,
    renderComponent(FullPageLoading),
);

export default spinnerWhileLoading;



// WEBPACK FOOTER //
// ./src/client/hoc/spinnerWhileLoading.js